function isEmptyValue(value: any): boolean {
  if (value === undefined || value === null || value === false) {
    return true
  }

  if (Array.isArray(value) && value.length === 0) {
    return true
  }

  if (typeof value === 'object' && !Array.isArray(value)) {
    if (Object.keys(value).length === 0) {
      return true
    }
  }

  return false
}

export function areAllValuesInObjectEmpty(obj: { [key: string]: any }): boolean {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !isEmptyValue(obj[key])) {
      return false
    }
  }

  return true
}

export function countNonEmptyValuesInObject(obj: { [key: string]: any }): number {
   return Object.keys(obj).filter((key: string) => !isEmptyValue(obj[key])).length
}
